export function extractDocId(text?: string) {
  if (!text) return undefined;

  const urlString = text.split('-');
  return urlString[urlString.length - 1];
}
